// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1YBAU","label":"SetPasswdForm_label__37x9W"};